/**
 * 1시간 자동 동기화 — 화면 데이터 정합성 안전망.
 *
 * 등록·수정 mutation 의 invalidateQueries 가 누락된 경우에도, 1시간 후에는
 * 자동으로 모든 쿼리가 무효화되어 다시 fetch 되므로 화면이 최신 상태를 회복.
 *
 * 즉시 반영(mutation invalidate) → 수동 새로고침(LastUpdateBadge ↻) → 자동 1시간 의 3중 안전망.
 *
 * 마운트 위치: App.tsx Shell (로그인 후 모든 페이지에서 1회만 마운트되도록).
 */

import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';

const SYNC_INTERVAL_MS = 60 * 60 * 1000; // 1시간

export function AutoSyncTicker() {
  const qc = useQueryClient();

  useEffect(() => {
    const id = setInterval(() => {
      void qc.invalidateQueries();
    }, SYNC_INTERVAL_MS);
    return () => clearInterval(id);
  }, [qc]);

  return null;
}
